module.exports = __webpack_public_path__ + "static/media/backgound-faqs-owners.6732b83d.jpg";